<script>
  import Layout from '@layout/main'
  // import { conditionList } from "@utils/is-condition";
  import Box from '@components/List/Box'

  export default {
    components: {
      Layout,
      Box,
    },
    data() {
      return {
        contactList: {
          title: '聯絡我們',
          alias: 'contactMenu',
          img: require('@assets/images/contact/banner.png'),
          class: "isStyleBase",
          col: 6,
          pagelist: [
            {
              text: '業務洽詢',
              to: {
                name: 'inquiry',
              },
              icon: '<i class="icomoon icon-primary-file"></i>',
            },
            {
              text: '聯絡銷售人員',
              to: {
                name: 'contactSales',
              },
              icon: '<i class="icomoon icon-primary-contact"></i>',
            },
            {
              text: '營業據點',
              to: {
                name: 'location',
              },
              icon: '<i class="icomoon icon-location color-primary"></i>',
            },
            {
              text: '維修服務',
              to: {
                name: 'repair',
              },
              icon: '<i class="icomoon icon-primary-fixed"></i>',
            },
          ]
        },
        aboutList: {
          title: '關於零壹',
          alias: 'aboutMenu',
          img: require('@assets/images/about/banner.png'),
          class: "isStyleLong",
          col: 12,
          pagelist: [
            {
              text: '公司簡介',
              to: {
                name: 'about-zerone',
              },
              icon: null,
              img: require('@assets/images/icon/icon-about.svg'),
            },
            {
              text: '經營團隊',
              to: {
                name: 'about-organization',
              },
              icon: '<i class="fal fa-users color-primary"></i>'
            },
            {
              text: '大事紀',
              to: {
                name: 'about-history',
              },
              icon: '<i class="fal fa-history color-primary"></i>'
            },
          ]
        },
      }
    },
    computed: {
      menuList() {
        const routerMap = {
          'about-menu': this.aboutList,
          'contact-menu': this.contactList,
        }

        return routerMap[this.$route.name]
      }
    },
    methods: {
      
    }
  }
</script>
<template>
  <Layout>
    <BaseBanner
      :title="menuList.title"
      :image="menuList.img"
      type="isMobileHasBg"
      custom-class="isStyleWhite"
    />
    <div class="container section" :class="$style.pageMenu">
      <div v-if="menuList.pagelist" class="row mobileGutter">
        <template
          v-for="(page, index) in menuList.pagelist"
        >
          <Box
            :key="`page-${index}`"
            class="mt-3"
            :class="[`col-${menuList.col}`, menuList.class]"
            :item="page"
          />
        </template>
      </div>
    </div>
  </Layout>
</template>
<style lang="scss" module>
.pageMenu {
  // @include max-md {
  //   padding-bottom: 3rem;
  // }
}
</style>
